export default __webpack_public_path__ + "static/media/goal.f71e4f07.svg";